// Successful storefront actions are the source of ecommerce events.
(function () {
  'use strict';
  const config = window.miracleMatStorefront;
  if (!config || !config.routes) return;
  const pendingForms = new Map();

  function track(name, data) {
    if (typeof window.gtag !== 'function') return;
    // A blocked analytics provider must never interrupt a successful purchase action.
    try { window.gtag('event', name, data); } catch (_) { /* Analytics is optional. */ }
  }

  function checkoutData(cart) {
    const data = { currency: cart && cart.currency || config.currency };
    if (cart && Array.isArray(cart.items)) {
      data.value = Number(cart.total_price || 0) / 100;
      data.items = cart.items.map(function (item) {
        return {
          item_id: String(item.variant_id || item.id),
          item_name: item.product_title || item.title,
          price: Number(item.final_price ?? item.price ?? 0) / 100,
          quantity: item.quantity
        };
      });
    }
    return data;
  }

  function restoreForm(form) {
    const controls = pendingForms.get(form);
    if (!controls) return;
    controls.forEach(function (entry) { entry.control.disabled = entry.disabled; });
    form.removeAttribute('aria-busy');
    pendingForms.delete(form);
  }

  function goToCheckout() {
    // Native cart checkout respects Shopify checkout settings and the existing cart.
    const form = document.createElement('form');
    form.method = 'post';
    form.action = config.routes.cart;
    const checkout = document.createElement('input');
    checkout.type = 'hidden';
    checkout.name = 'checkout';
    checkout.value = 'Checkout';
    form.appendChild(checkout);
    document.body.appendChild(form);
    form.submit();
  }

  document.addEventListener('submit', async function (event) {
    const form = event.target;
    if (!form || !form.matches) return;
    const submitter = event.submitter || document.activeElement;
    if (!form.matches('.product-purchase-form')) {
      // Normal checkout forms keep their native submission behavior.
      if (submitter && submitter.name === 'checkout' && new URL(form.action, window.location.href).pathname === new URL(config.routes.cart, window.location.href).pathname) {
        track('begin_checkout', checkoutData(config.cart));
      }
      return;
    }
    if (typeof window.fetch !== 'function' || typeof FormData !== 'function') return;
    event.preventDefault();
    if (pendingForms.has(form)) return;
    if (form.reportValidity && !form.reportValidity()) return;

    const data = new FormData(form);
    const productRoot = form.closest('[data-product-title]');
    const errorElement = form.querySelector('[data-product-error]');
    const quantity = Number(data.get('quantity') || 1);
    if (!Number.isSafeInteger(quantity) || quantity < 1 || !data.get('id')) {
      if (errorElement) {
        errorElement.textContent = 'Please select an available option and a valid quantity.';
        errorElement.classList.remove('hidden');
      }
      return;
    }
    const controls = Array.from(form.querySelectorAll('button, input, select')).map(function (control) {
      return { control: control, disabled: control.disabled };
    });
    pendingForms.set(form, controls);
    controls.forEach(function (entry) { entry.control.disabled = true; });
    form.setAttribute('aria-busy', 'true');
    if (errorElement) errorElement.classList.add('hidden');
    let navigating = false;
    try {
      const response = await window.fetch(config.routes.add, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Accept': 'application/json' },
        body: data
      });
      const payload = await response.json();
      if (!response.ok) throw new Error(payload.description || payload.message || 'Unable to add this item.');
      const item = Array.isArray(payload.items) ? payload.items[0] : payload;
      if (!item || !(item.variant_id || item.id)) throw new Error('Unable to confirm the added item. Please check your cart before retrying.');
      const price = Number(item.final_price ?? item.price ?? 0) / 100;
      track('add_to_cart', {
        currency: config.currency,
        value: price * quantity,
        items: [{
          item_id: String(item.variant_id || item.id),
          item_name: item.product_title || (productRoot && productRoot.dataset.productTitle),
          price: price,
          quantity: quantity
        }]
      });
      // No Google Ads order conversion is emitted here. Orders belong to the
      // configured checkout/purchase integration, not a product-form submission.
      if (submitter && submitter.name === 'checkout') {
        let cart;
        try {
          const cartResponse = await window.fetch(config.routes.cartJson, { credentials: 'same-origin', headers: { 'Accept': 'application/json' } });
          if (cartResponse.ok) cart = await cartResponse.json();
        } catch (_) { /* Checkout can proceed even if the analytics snapshot fails. */ }
        track('begin_checkout', checkoutData(cart));
        goToCheckout();
      } else {
        window.location.assign(config.routes.cart);
      }
      navigating = true;
    } catch (error) {
      if (errorElement) {
        errorElement.textContent = error.message || 'Unable to add this item. Please try again.';
        errorElement.classList.remove('hidden');
        errorElement.focus();
      }
    } finally {
      if (!navigating) restoreForm(form);
    }
  });

  // Direct checkout links also retain their normal navigation.
  document.addEventListener('click', function (event) {
    const link = event.target.closest && event.target.closest('a[href]');
    if (!link || event.defaultPrevented || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    const destination = new URL(link.href, window.location.href);
    const checkout = new URL(config.routes.checkout, window.location.href);
    if (destination.origin === checkout.origin && destination.pathname === checkout.pathname) {
      track('begin_checkout', checkoutData(config.cart));
    }
  });

  // A browser back/forward-cache restore must not leave purchase controls locked.
  window.addEventListener('pageshow', function () {
    Array.from(pendingForms.keys()).forEach(restoreForm);
  });
})();
